import Vue from "vue"
import icon from "./common/icon"
import moment from "./common/moment"
import progressbar from "./common/progressbar"
import infobar from "./common/infobar"
import imagec from "./common/imagec"

Vue.component("icon", icon)
Vue.component("moment", moment)
Vue.component("progress-bar", progressbar)
Vue.component("info-bar", infobar)
Vue.component("imagec", imagec)
